import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";
import React from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import CopyRight from "../../Assets/CopyRight";
import Button from "../../components/Button";
import Gap from "../../components/Gap";
import InputPhone from "../../components/InputPhone";
import { router } from "../../Constants";
import app from "../../firebase";
import { showLog } from "../../utils/log";

function Home() {
  const { addToast } = useToasts();
  let navigate = useNavigate();
  const [captchaCalled, setCaptchaCalled] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [timeOut, setTimeOut] = React.useState("Send OTP");
  const [input, setInput] = React.useState({
    mobile: "",
    otp: "",
  });

  function configureCaptcha() {
    showLog("Login Masuk configureCaptcha");
    const auth = getAuth(app);
    window.recaptchaVerifier = new RecaptchaVerifier(
      "sign-in-button",
      {
        size: "invisible",
        callback: (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          setCaptchaCalled(true);
          onSignInSubmit();
        },
      },
      auth
    );
  }

  function startTimer(duration) {
    showLog("Login Masuk startTimer");
    let timer = duration,
      minutes,
      seconds;
    let myVar = setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      let date = seconds;
      if (date == "00") {
        clearInterval(myVar);
        setTimeOut("Send OTP");
        localStorage.removeItem("timeout");
      } else {
        setTimeOut(date);
        localStorage.setItem("timeout", parseInt(timer));
      }
      if (--timer < 0) {
        timer = duration;
      }
    }, 1000);
  }

  React.useEffect(() => {
    showLog("Login Masuk useEffect 1");
    const xi = localStorage.getItem("timeout");
    if (xi) {
      startTimer(Number(xi));
    }
  }, []);

  // async function onSignIn(e) {
  //   showLog("Login Masuk onSignIn");
  //   setLoading(true);
  //   const phoneNumber = "+62" + input.mobile.replace(/ /g, "");
  //   if (!input.mobile) {
  //     setLoading(false);
  //     addToast("No Telepon harus diisi", {
  //       appearance: "error",
  //       autoDismiss: true,
  //     });
  //     return;
  //   }
  //   if (captchaCalled === false) {
  //     configureCaptcha();
  //   }
  //   // const phoneNumber = '+62'+input.mobile.replace(/\s/g, '');
  //   const appVerifier = window.recaptchaVerifier;
  //   const auth = getAuth();
  //   signInWithPhoneNumber(auth, phoneNumber, appVerifier)
  //     .then((confirmationResult) => {
  //       window.confirmationResult = confirmationResult;
  //     })
  //     .catch((error) => {
  //       if (
  //         error.code === "auth/invalid-phone-number" ||
  //         error.code === "auth/user-not-found"
  //       ) {
  //         addToast(
  //           "Nomor Telepon anda tidak terdaftar, mohon untuk mendaftar terlebih dahulu",
  //           {
  //             appearance: "error",
  //             autoDismiss: true,
  //           }
  //         );
  //       } else {
  //         addToast("An unknown error occured.", {
  //           appearance: "error",
  //           autoDismiss: true,
  //         });
  //       }
  //     });
  // }

  async function onSignIn(e) {
    showLog("Login Masuk onSignIn");
    setLoading(true);
    const phone = input.mobile.replace(/ /g, "");
    if (!phone) {
      setLoading(false);
      addToast("No Telepon harus diisi", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    const phoneNumber = "+62" + phone;
    const valid = /^\+62\d{8,13}$/.test(phoneNumber);
    if (!valid) {
      setLoading(false);
      addToast("Nomor Telepon tidak valid", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    if (!window.recaptchaVerifier) {
      configureCaptcha();
    }
    try {
      const auth = getAuth(app);
      const appVerifier = window.recaptchaVerifier;
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        phoneNumber,
        appVerifier
      );
      window.confirmationResult = confirmationResult;
      showLog("Kode OTP dikirim.");
      navigate(`${router}/kode-otp`);
    } catch (error) {
      showLog(`Error in signInWithPhoneNumber = ${error.message}, ${error}`);
      const msg =
        error.code === "auth/invalid-phone-number" ||
        error.code === "auth/user-not-found"
          ? "Nomor Telepon anda tidak terdaftar, mohon untuk mendaftar terlebih dahulu"
          : "An unknown error occurred.";
      addToast(msg, {
        appearance: "error",
        autoDismiss: true,
      });
    } finally {
      setLoading(false);
    }
  }

  function onSignInSubmit(e) {
    showLog("Login Masuk onSignInSubmit");
    e.preventDefault();
    onSignIn();
  }

  return (
    <div>
      <div>
        <div
          style={{ marginTop: 10, marginLeft: 5, padding: 10 }}
          onClick={() => {
            navigate(`${router}/`);
          }}
        >
          <BiArrowBack size={20} />
        </div>
      </div>
      <div style={{ margin: "20% 20% 10px 20%" }}>
        <div
          style={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            padding: "30px 0px",
          }}
        >
          <div style={{ fontSize: 25 }} className="fonts700">
            Halo! Selamat Datang
          </div>
        </div>
        <InputPhone
          type="input"
          value={input.mobile}
          label="Nomer Handphone"
          placeholder="8123456789"
          onChange={(val) => {
            setInput((prevState) => ({
              ...prevState,
              mobile: val,
            }));
          }}
        />
        <Gap height={20} />
        <Button
          onClick={(e) => {
            if (!loading) {
              if (timeOut == "Send OTP") {
                onSignInSubmit(e);
              }
            }
          }}
          loading={loading}
          color="#fff"
          backgroundColor={timeOut == "Send OTP" ? "#5451D6" : "#b5b5b5"}
        >
          {timeOut}
        </Button>
      </div>
      <div style={{ marginTop: "70%", textAlign: "center" }}>
        <CopyRight />
      </div>
      <div id="sign-in-button"></div>
    </div>
  );
}

export default Home;
